export interface FaqItem {
  id: string;
  title: string;
  content: string;
}

export const faqItems: readonly FaqItem[] = [
  {
    id: "service-areas",
    title: "Which areas do you service?",
    content:
      "We provide same-day appliance repair across Orange County and the surrounding communities. If you are unsure whether we can reach you, give our team a call and we will confirm availability right away.",
  },
  {
    id: "booking",
    title: "How do I book an appointment?",
    content:
      "Use the online scheduler to pick a time that works for you or call our dispatch directly. Once we confirm your details, you will receive a text and email with the visit window and technician information.",
  },
  {
    id: "visit-cost",
    title: "What should I expect to pay?",
    content:
      "Our diagnostic visit has a flat fee that is waived when you approve the repair. Before any work begins we review the parts, labor, and warranty so you always know the total investment.",
  },
  {
    id: "warranty",
    title: "Do repairs include a warranty?",
    content:
      "Yes. Every completed repair includes a parts and labor warranty. If an issue returns within the covered window, we come back to make things right at no additional cost.",
  },
  {
    id: "service-call-fee",
    title: "What Is the Service Call Fee?",
    content:
      "The service call fee covers the cost of a technician traveling to your location, diagnosing the issue, and providing a detailed estimate for the repair. It ensures that a licensed professional arrives equipped with the tools and expertise needed to evaluate your appliance properly. This fee is not an extra charge — if you proceed with the repair, the service call fee is applied toward the total cost of the job. You only pay it separately if no repair is authorized after the diagnosis.",
  },
  {
    id: "how-can-i-pay",
    title: "How Can I Pay?",
    content:
      "We accept various payment methods for your convenience, including bank checks, credit and debit cards, electronic payments (Venmo, Zelle), and cash.",
  }
];
